var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19936_600)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9166 35.45C17.0233 35.45 14.6666 33.0957 14.6666 30.2C14.6666 28.3613 15.635 26.6533 17.1936 25.748C18.029 25.2627 19.1 25.5473 19.5853 26.3803C20.0706 27.2157 19.7883 28.2867 18.953 28.772C18.4606 29.059 18.1666 29.5933 18.1666 30.2C18.1666 31.166 18.953 31.95 19.9166 31.95C20.8803 31.95 21.6666 31.1637 21.6666 30.2C21.6666 29.9503 21.6176 29.7357 21.5196 29.549C21.0693 28.695 21.3936 27.6357 22.2476 27.183C23.0993 26.728 24.1586 27.057 24.6136 27.911C24.98 28.6063 25.1666 29.3763 25.1666 30.2C25.1666 33.0957 22.81 35.45 19.9166 35.45Z",
    fill: "#FE921D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2499 34.3393C36.0865 34.3393 35.9185 34.316 35.7575 34.2693L11.2575 27.0967C10.5132 26.8773 9.99988 26.1937 9.99988 25.4167V21.9167C9.99988 21.135 10.5179 20.449 11.2692 20.2343L35.7692 13.2343C36.2942 13.0873 36.8682 13.1877 37.3022 13.5213C37.7432 13.8503 37.9999 14.3683 37.9999 14.9167V32.5893C37.9999 33.14 37.7409 33.658 37.2975 33.9893C36.9919 34.2203 36.6232 34.3393 36.2499 34.3393Z",
    fill: "#FFC326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2499 35.3333C35.2839 35.3333 34.4999 34.5493 34.4999 33.5833V13.75C34.4999 12.784 35.2839 12 36.2499 12C37.2159 12 37.9999 12.784 37.9999 13.75V33.5833C37.9999 34.5493 37.2159 35.3333 36.2499 35.3333Z",
    fill: "#FEA21E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7499 28.3333C10.7839 28.3333 9.99988 27.5493 9.99988 26.5833V20.75C9.99988 19.784 10.7839 19 11.7499 19C12.7159 19 13.4999 19.784 13.4999 20.75V26.5833C13.4999 27.5493 12.7159 28.3333 11.7499 28.3333Z",
    fill: "#FEA21E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19936_600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.617a0fc26dba57c38642357a50fd35ec.svg";
export { ForwardRef as ReactComponent };